import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../../shared/utility';

const intialState = {
    cartItems: [ ],
    cartQuantity: null,
    addingProduct: false,
    errorAddingProduct: false,
    removingProduct: false,
    errorRemovingProduct: false,
    fetchingCart: false,
    errorFetchingCart: false,
    deletingCart: false,
    errorDeletingCart: false,
} ;

const reducer = ( state = intialState , action ) => {
    switch( action.type ) {
        case ( actionTypes.ADD_PRODUCT_START ): 
        return updateObject( state , {
            addingProduct: true,
            errorAddingProduct: false,
        } )
        case ( actionTypes.ADD_PRODUCT_SUCCESS ): 
        let updatedCart = [...state.cartItems];
        updatedCart.push(action.addedProduct);
        let editedCartQuantity = state.cartQuantity + action.addedQuantity ;
        localStorage.setItem('cartItems',updatedCart)
        localStorage.setItem('cartQuantity', editedCartQuantity)
            return updateObject( state , {
                addingProduct: false,
                cartItems: updatedCart,
                cartQuantity: editedCartQuantity
            } )
        case ( actionTypes.ADD_PRODUCT_FAILED ): 
            return updateObject( state , {
                addingProduct: false,
                errorAddingProduct: action.error,
            } )
        case ( actionTypes.INCREASE_PRODUCT_START ): 
            return updateObject( state , {
                addingProduct: true,
                errorAddingProduct: false,
            } )
        case ( actionTypes.INCREASE_PRODUCT_SUCCESS ): 
            // We Indicate The Index Of The Product
            const itemIndex = state.cartItems.findIndex( item => {
                return item.orderId === action.productId
            } )
            // We Make A Copy Of The Product
            let modifiedItem = {...state.cartItems[itemIndex]};
            // We Edit It
            modifiedItem.quantity = action.productQuantity
            // We Make A Clone Of The Cart
            let modifiedCart =[...state.cartItems];
            // We Update It
            modifiedCart[itemIndex] = modifiedItem;
            // We Add The Quantity To The Cart Quantity
            let modifiedCartQuantity = state.cartQuantity + action.quantityAdded;
            localStorage.setItem('cartItems',modifiedCart)
            localStorage.setItem('cartQuantity', modifiedCartQuantity)
            return updateObject ( state , { 
                cartItems: modifiedCart,
                cartQuantity: modifiedCartQuantity
            })
        case ( actionTypes.INCREASE_PRODUCT_FAILED ): 
            return updateObject( state , {
                addingProduct: false,
                errorAddingProduct: action.increaseError,
            } )
        case ( actionTypes.REMOVE_PRODUCT_START ): 
            return updateObject( state , {
                removingProduct: true,
                errorAddingProduct: false,
            } )
        case ( actionTypes.REMOVE_PRODUCT_SUCCESS ): 
            const removedItemIndex = state.cartItems.findIndex( item => {
                return item.orderId === action.removedProductId
            } )
            let updatedCartItems = state.cartItems.filter( item => item.orderId !== action.removedProductId )
            let updatedCartQuantity = state.cartQuantity - state.cartItems[removedItemIndex].quantity ;
            localStorage.setItem('cartItems',updatedCartItems)
            localStorage.setItem('cartQuantity', updatedCartQuantity)
            return updateObject( state , {
                removingProduct: false,
                cartItems: updatedCartItems,
                cartQuantity: updatedCartQuantity,
            } )
        case ( actionTypes.REMOVE_PRODUCT_FAILED ): 
            return updateObject( state , {
                removingProduct: false,
                errorAddingProduct: action.removeError,
            } )
        
        case ( actionTypes.FETCH_CART_START ): 
            return updateObject( state , {
                fetchingCart: true,
                errorFetchingCart: false,
            } )
        case ( actionTypes.FETCH_CART_SUCCESS ): 
            localStorage.setItem('cartItems',action.cartProducts)
            localStorage.setItem('cartQuantity', action.cartQuantity)
            return updateObject ( state , { 
                cartItems: action.cartProducts,
                cartQuantity: action.cartQuantity,
                fetchingCart: false,
            })
        case ( actionTypes.FETCH_CART_FAILED ) :
            return updateObject( state , {
                fetchingCart: false,
                errorFetchingCart: action.error,
            } )
        case ( actionTypes.DELETE_CART_START ): 
            return updateObject( state , {
                deletingCart: true,
                errorDeletingCart: false,
            } )
        case ( actionTypes.DELETE_CART_SUCCESS ): 
            return intialState
        case ( actionTypes.DELETE_CART_FAILED ) :
            return updateObject( state , {
                deletingCart: false,
                errorDeletingCart: action.error,
            } )
        default : 
            return state
    }
};
export default reducer;
